<template>
  <div class="mit-actions-new-person pa-5">
    <BaseMitLoading :show="loading" :fullscreen="false"/>
    <v-card flat>
      <v-card-title>TBD</v-card-title>
      <v-card-text>TBD description</v-card-text>
    </v-card>
    <BaseMitDataTable
      title="People In Progress"
      :page="paging.page"
      :pageSize="paging.pageSize"
      :totalItems="paging.totalItems"
      :pageSizes="{itemsPerPageOptions:[10, 20, 50, 100]}"
      :editable="false"
      :headers="headers"
      :items="activity"
      :showExpanded="true" 
      itemKey="id"
      :singleExpanded="false"
      @pagination="updatePagination"
    >
    </BaseMitDataTable>
  </div>
</template>

<script>
import moment from 'moment';

import BaseMitDataTable from '../../../base/components/BaseMitDataTable.vue';
import BaseMitUrlParams from '../../../base/components/BaseMitUrlParams.vue';
import BaseMitLoading from '../../../base/components/BaseMitLoading.vue';
import BaseMitReservationReadOnly from '../../../base/components/reserve/BaseMitReservationReadOnly.vue';

import MitPeopleService from '../../services/MitPeopleService.js';

export default {
  name: 'MitActionsNewPerson',
  components: {
    BaseMitLoading,
    BaseMitDataTable,
    BaseMitUrlParams,
    BaseMitReservationReadOnly
  },
  props: {
  },
  data: function() {
    return {
      dialog:false,
      filterItem:null,
      filterValue:'',
      loading:false,
      search: '',
      options:{},
      paging:{
        page:1,
        pageSize:5,
        totalItems:0
      },
      filterableHeaders:[ //moment().local().format("hh:mm A")
        {text: 'CSAIL ID',value: 'userId', default:'', hint:'The exact csail id'},
        {text: 'User Role',value: 'userRole', default:'', hint:'The exact userRole'},
        {text: 'Space',value: 'mitId', default:'', hint:'The exact space id'},
        {text: 'Type',value: 'type', default:'', hint:'The exact type "created", "updated", "deleted" or "reverted"'},
        {text: 'Id',value: 'id', default:'', hint:'The exact id of the activity'},
        {text: 'Unique Id',value: 'uniqueId', default:'', hint:'The exact unique id of the reservation'},
        {text: 'Unique Id Series',value: 'recurringUniqueId', default:'', hint:'Enter the recurring unique id, will display edits users made to individual events in this recurring series'}
        // {text: 'Start Date',value: 'startDt', default:MitActivityApiService.getActivityDateStringLocal(), hint:'Create Date >=. Format is "YYYY-MM-DD HH:mm:ss" 24h local time.'},
        // {text: 'End Date',value: 'endDt', default:MitActivityApiService.getActivityDateStringLocal(), hint:'End Date <=. Format is "YYYY-MM-DD HH:mm:ss" 24h local time.'},
      ],
      headers:[
          {text: 'Id',sortable: true,value: 'id'},
          {text: 'Type',sortable: true,value: 'type'},
          {text: 'Reservation ID',sortable: true,value: 'uniqueId'},
          {text: 'Space',sortable: false,value: 'data.mitId'},
          {text: 'Changed By User',sortable: true,value: 'userId'},
          {text: 'User Role',sortable: true,value: 'userRole'},
          {text: 'Date',sortable: true,value: 'createDt'}
        ],
      activity:[]
    }
  },
  created() {

  },
  methods : {
    updatePagination (pagination) {
      //setting this into the control will trigger this event so initiall don't bother refreshing
      //if the items length is zero, we have no data yet.
      if(pagination.itemsLength > 0){
        this.paging.page = pagination.page;
        this.paging.pageSize = pagination.itemsPerPage;

        this.refreshData(this.paging, this.options);
      }

    },
    updateFilters(options){
      this.options = options;
      this.paging.page = 1;//we changed the filter so start over with a new data set
      this.refreshData(this.paging, this.options);
    },
    refreshData(pagination, options){
      this.loading = true;
      // MitActivityApiService.requestGetActivity(pagination, options)
      //   .then((data) => {
      //     this.loading = false;

      //     this.activity = data.activity;
      //     this.paging.totalItems = data.total;
      //   })
      //   .catch((error) => {
      //     this.loading = false;
      //     console.log('An error occurred trying to get keys list', error);
      //   });
    },
    resetDialog(){
      this.filterItem = this.filterableHeaders[5];
      this.filterValue = null;
    },
    changedFilter(item){
      this.filterValue = item.default;
    },
    addFilter(){
      // if(MitActivityApiService.isActivityDateTimeValid(this.filterValue)){
      //   this.filterValue = MitActivityApiService.getActivityDateStringUtc(this.filterValue);
      // }

      this.$refs.mitUrlParamsRef.add(this.filterItem.value, this.filterValue);
      this.dialog = false;
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
